import React from "react";
import CodeMirror from "@uiw/react-codemirror";
import { javascript } from "@codemirror/lang-javascript";
import { python } from "@codemirror/lang-python";
import { minimalSetup } from "codemirror";          // or basicSetup

export interface CodeEditorProps {
  language: "javascript" | "python";
  code: string;
  onChange?: (code: string) => void;
  height?: number | string;
}

export default function CodeEditor({
  language,
  code,
  onChange,
  height = 260,
}: CodeEditorProps) {
  const extensions = [
    minimalSetup,                                   // leaner than basicSetup
    language === "python"
      ? python()
      : javascript(),
  ];

  return (
    <CodeMirror
      value={code}
      height={typeof height === "number" ? `${height}px` : height}
      extensions={extensions}
      onChange={(val) => onChange?.(val)}
      basicSetup={false}  // we supply our own preset
    />
  );
}
